import { render, staticRenderFns } from "./Scotland2.vue?vue&type=template&id=65280e4d"
import script from "./Scotland2.vue?vue&type=script&lang=js"
export * from "./Scotland2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports